// Shared form helpers for partition popovers (Slice E1).
//
// Parses a multiline `name = values-text` block into draft rows. Each line
// becomes one `{ name, values }` pair. Lines without an `=` are skipped.

export interface PartitionRowDraft {
  readonly name: string;
  readonly values: string;
}

export function parsePartitionRowsInput(input: string): PartitionRowDraft[] {
  const out: PartitionRowDraft[] = [];
  for (const line of input.split('\n')) {
    const trimmed = line.trim();
    if (trimmed.length === 0) continue;
    const eqIdx = trimmed.indexOf('=');
    if (eqIdx < 0) continue;
    const name = trimmed.slice(0, eqIdx).trim();
    const values = trimmed.slice(eqIdx + 1).trim();
    if (name.length === 0) continue;
    out.push({ name, values });
  }
  return out;
}
